import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/context/CartContext";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_wellness-shots/artifacts/dibvmg73_kens%20gold.png";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/benefits", label: "Benefits" },
  { to: "/crafting-storage", label: "How It’s Made", id: "how-its-made" },
  { to: "/wellness", label: "Wellness" },
  { to: "/origin", label: "Our Story" },
];

function NavLogo() {
  return (
    <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">
      <img src={LOGO_URL} alt="Ken's Gold Logo" className="w-8 h-8 rounded-full object-cover" />
      <span className="font-playfair text-lg">
        <span className="text-brown-dark font-semibold">Ken's</span>{" "}
        <span className="text-gold font-bold">Gold</span>
      </span>
    </Link>
  );
}

function DesktopNav({ pathname }) {
  return (
    <div className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
      {navLinks.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className={`nav-link text-sm ${pathname === link.to ? "active" : ""}`}
          data-testid={`nav-link-${link.id || link.label.toLowerCase().replace(/\s/g, "-")}`}
        >
          {link.label}
        </Link>
      ))}
    </div>
  );
}

function MobileNav({ pathname, onClose }) {
  return (
    <div className="lg:hidden border-t border-gold/10 bg-cream-light px-6 py-4 space-y-3" data-testid="mobile-nav">
      {navLinks.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className={`block py-2 text-sm font-medium ${pathname === link.to ? "text-gold" : "text-brown-dark"}`}
          onClick={onClose}
          data-testid={`mobile-nav-link-${link.id || link.label.toLowerCase().replace(/\s/g, "-")}`}
        >
          {link.label}
        </Link>
      ))}
    </div>
  );
}

export default function Navbar() {
  const { pathname } = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { count, setDrawerOpen } = useCart();

  return (
    <nav className="navbar" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <NavLogo />
        <DesktopNav pathname={pathname} />
        <div className="flex items-center gap-4">
          <button className="relative text-brown-dark hover:text-gold transition-colors" onClick={() => setDrawerOpen(true)} data-testid="cart-button">
            <ShoppingCart size={22} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-gold text-white text-[10px] font-bold rounded-full w-4.5 h-4.5 min-w-[18px] min-h-[18px] flex items-center justify-center" data-testid="cart-count-badge">{count}</span>
            )}
          </button>
          <button className="lg:hidden text-brown-dark" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle" aria-label="Toggle navigation" aria-expanded={mobileOpen}>
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {mobileOpen && <MobileNav pathname={pathname} onClose={() => setMobileOpen(false)} />}
    </nav>
  );
}
